import { getVacancyIdFromMatch } from 'utils/campaign';
import { SettingsConfig } from 'utils/constants/dynamicSettings';

import { Requirements } from 'app/routes';

import { getAuctionDataActionCreators, getAuctionDataUrl } from 'components/AuctionBuilder/fetchAuctionData';

import { AvailablePromos, setAvailablePromos } from 'store/autoReducers';
import { AuctionData } from 'store/models/auctionData';

export const AuctionBuilderRequirements: Requirements<{
    auctionData: AuctionData;
    availablePromos: { availablePromoBonuses: AvailablePromos };
    dynamicSettings: Partial<SettingsConfig>;
}> = {
    methods: ({ match }) => {
        const vacancyId = getVacancyIdFromMatch(match);

        return {
            ...(vacancyId && {
                auctionData: { url: getAuctionDataUrl(vacancyId), cacheable: false },
                availablePromos: { url: '/api/v1/promos/available', cacheable: false },
            }),
        };
    },
    resolve: ({
        state,
        result: {
            auctionData,
            availablePromos: { availablePromoBonuses },
        },
    }) => {
        return [
            ...(auctionData
                ? getAuctionDataActionCreators(auctionData, state.user.user?.currentAccount.dynamicPriceEnabled)
                : []),
            ...(availablePromoBonuses ? [setAvailablePromos(availablePromoBonuses)] : []),
        ];
    },
};
